/* section-collection.js — extracted from sections/collection.liquid */
(function () {
    function initCollectionControls() {
      var select = document.querySelector('[data-collection-sort]');
      if (!select || select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    document.addEventListener('DOMContentLoaded', initCollectionControls);
    document.addEventListener('shopify:section:load', initCollectionControls);
    initCollectionControls();
  })();
